import { z, ZodType } from 'zod';

export type Game = {
	id: number;
	isLocked: boolean;
	account: {
		id: number;
		name: string;
	};
	game: {
		id: number;
		title: string;
	};
};

export const gameSchema: ZodType<Game> = z.object({
	id: z.number(),
	isLocked: z.boolean(),
	account: z.object({
		id: z.number(),
		name: z.string(),
	}),
	game: z.object({
		id: z.number(),
		title: z.string(),
	}),
});
